require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/es6.typed.float32-array.js
// module id = ../../../node_modules/core-js/modules/es6.typed.float32-array.js
// module chunks = 0